import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DatePicker, Form, Input, Select, Checkbox, message } from 'antd';

import CRUDE_City from '../../../objects/City/crude'
import REDUX_City from '../../../objects/City/reducer'
import REDUX_TipiMeropriyatii from '../../../objects/TipiMeropriyatii/reducer'
import REDUX_UrovenMeropriyatiya from '../../../objects/UrovenMeropriyatiya/reducer'
import { errorCatch, GET, useFormObserverContext, useUserConfigContext } from 'fennec-ui';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import locale from 'antd/es/date-picker/locale/ru_RU';
import EmojiTextArea from '../../../common/EmojiTextArea';
dayjs.locale('ru');


const { Option } = Select;


export default function IzmenitMeropriyatiyaTexts(props) {
    const { auth, object, form, sourceKey } = props;
    const dispatch = useDispatch();

    const [userConfig, setUserConfig] = useUserConfigContext();
    // setUserConfig("uitranspose", val, menuClose) 


    const city = useSelector(REDUX_City.selector.array);
    const tipMeropriyatiya = useSelector(REDUX_TipiMeropriyatii.selector.array);
    const urovenMeropriyatiya = useSelector(REDUX_UrovenMeropriyatiya.selector.array);

    let orgKey = undefined;
    if (object?.organizatorFederatsiyaID) {
        orgKey = "fed";
    } else if (object?.organizatorRegionalnoeOtdelenieID) {
        orgKey = "reg";
    } else if (object?.organizatorMeropriyatiyaID) {
        orgKey = "org";
    } else if (object?.organizatorShkolaID) {
        orgKey = "school";
    }

    useEffect(() => {
        form.resetFields();
        CRUDE_City.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_City.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
        GET(auth, '/api/tipimeropriyatii/' + orgKey,
            ({ data }) => {
                dispatch(REDUX_TipiMeropriyatii.actions.setArray(data));
            },
            (err) => errorCatch(err));
        GET(auth, '/api/urovenmeropriyatiya/' + orgKey,
            ({ data }) => {
                dispatch(REDUX_UrovenMeropriyatiya.actions.setArray(data));
            },
            (err) => errorCatch(err));
    }, []);
    const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);
    const tipMeropriyatiyaOptions = tipMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const urovenMeropriyatiyaOptions = urovenMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    const _shapkaUsloviiVozvrata =
        `УСЛОВИЯ ВОЗВРАТА:
        👉 Возврат денежных средств за заказ возможен только в том случае, если заказ оплачен через сайт: https://social-dance.club. При покупке билетов через другие ресурсы действуют правила возврата, принятые на этих ресурсах.
        👉 Возврат ЧАСТИ ЗАКАЗА НЕВОЗМОЖЕН!!! Если вы предполагаете, что есть вероятность возврата заказа, то покупайте билеты разными заказами!! ВЕРНУТЬ МОЖНО ТОЛЬКО ВЕСЬ ЗАКАЗ ЦЕЛИКОМ!!
        👉 Переоформление заказа на другого участника НЕВОЗМОЖНО!! Особенно это актуально для парных пассов - если кто-то из участников хочет произвести возврат, то необходимо осуществить возврат всего заказа, и потом покупать заново.
        👉 Перенос заказа или части заказа НА ДРУГИЕ ДАТЫ НЕВОЗМОЖЕН!! Вам необходимо осуществить возврат заказа этого Фестиваля и сделать и оплатить заказ на другой Фестиваль.
        
        👉 Вы можете подать заявку на возврат заказа не позднее дня начала Фестиваля, нажав кнопку: «Возврат билета».
        👉 КНОПКА НАХОДИТСЯ в личном кабинете на сайте https://social-dance.club, ВНИЗУ пункт меню: "Главная", ВВЕРХУ закладка "Заказы".
                    
        👉 Возврат денежных средств за заказ осуществляется НА ВНУТРЕННИЙ АККАУНТ пользователя в течение 30 минут.
        👉 В день мероприятия прием заявлений на возврат заказов прекращается, денежные средства за заказ не возвращаются.`
    const _podvalUsloviiVozvrata =
        `👉 Если Вы хотите вернуть денежные средства со своего внутреннего аккаунта, Вам необходимо для этого подать заявление на возврат денежных средств на свою банковскую карту.
        👉 Заявление оформляется В ПРОИЗВОЛЬНОЙ ФОРМЕ с указанием фамилии, имени и способа возврата (например, банк по номеру телефона).
        👉 Заявление подается в ТЕЛЕГРАМ на номер 89859241061 (НЕ В ВОТСАПП, НЕ В ВК, а именно В ТЕЛЕГРАМ!!!).
        👉 Возврат средств с внутреннего аккаунта на банковскую карту осуществляется в течение 10 дней после подачи такого заявления.`

    const priceText = userConfig?.priceText || "";
    const shapkaUsloviiVozvrata = userConfig?.shapkaUsloviiVozvrata || _shapkaUsloviiVozvrata;
    const podvalUsloviiVozvrata = userConfig?.podvalUsloviiVozvrata || _podvalUsloviiVozvrata;

    const setPriceText = useCallback((value) => {
        setUserConfig("priceText", value, () => { message.success("Значение по умолчанию сохранено") })
    }, [setUserConfig])
    const setShapkaUsloviiVozvrata = useCallback((value) => {
        setUserConfig("shapkaUsloviiVozvrata", value, () => { message.success("Значение по умолчанию сохранено") })
    }, [setUserConfig])
    const setPodvalUsloviiVozvrata = useCallback((value) => {
        setUserConfig("podvalUsloviiVozvrata", value, () => { message.success("Значение по умолчанию сохранено") })
    }, [setUserConfig])

    const [isChangedForm, isChangedField, onValuesChange] = useFormObserverContext()

    return (
        <>
            <Form
                form={form}
                onValuesChange={onValuesChange}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    nachaloRegistratsii: (object) ? dayjs(object.nachaloRegistratsii) : undefined,
                    nachaloAdministrativnogoKontrolya: (object) ? dayjs(object.nachaloAdministrativnogoKontrolya) : undefined,
                    okonchanieAdministrativnogoKontrolya: (object) ? dayjs(object.okonchanieAdministrativnogoKontrolya) : undefined,
                    nachaloSorevnovaniya: (object) ? dayjs(object.nachaloSorevnovaniya) : undefined,
                    okonchanieSorevnovaniya: (object) ? dayjs(object.okonchanieSorevnovaniya) : undefined,
                    priceText: (object) ? object.priceText : undefined,
                    shapkaUsloviiVozvrata: (object) ? object.shapkaUsloviiVozvrata : undefined,
                    podvalUsloviiVozvrata: (object) ? object.podvalUsloviiVozvrata : undefined,
                    reklama: (object) ? object.reklama : undefined,
                    reklamaPopup: (object) ? object.reklamaPopup : undefined,
                }}
            >
                <Form.Item label="Описание мероприятия"
                    tooltip="На странице мероприятия: общее описание мероприятия. Располагается вверху страницы под категориями участников."
                    name="priceText"
                >
                    <EmojiTextArea rows={8} defaultText={priceText} setAsDefault={setPriceText} />
                </Form.Item>
                <div style={{ marginTop: "30px" }}>
                    <Form.Item label="Текст над сеткой дат возвратов"
                        tooltip="На странице мероприятия в блоке условий возврата: текст над сеткой дат возвратов."
                        name="shapkaUsloviiVozvrata"
                    >
                        <EmojiTextArea rows={8} defaultText={shapkaUsloviiVozvrata} setAsDefault={setShapkaUsloviiVozvrata} />
                    </Form.Item>
                </div>
                <div style={{ marginTop: "30px" }}>
                    <Form.Item label="Текст под сеткой дат возвратов"
                        tooltip="На странице мероприятия в блоке условий возврата: текст под сеткой дат возвратов."
                        name="podvalUsloviiVozvrata"
                    >
                        <EmojiTextArea rows={8} defaultText={podvalUsloviiVozvrata} setAsDefault={setPodvalUsloviiVozvrata} />
                    </Form.Item>
                </div>
            </Form>
        </>
    );
}
